export const VIEWPORT_TYPE = {
  REALTIME: 'realtime',
  REALTIME_DASHBOARD: 'realtimeDashboard',
  PA: 'pa',
  PA_HEADER_TIME: 'paHeaderTime', // 분석보드 형태
  SETTING: 'setting',
  ERROR: 'error',
} as const;

export const VIEWPORT_OPTIONS = {
  [VIEWPORT_TYPE.REALTIME]: {
    useKeepAlive: false,
    useNavigationHeader: false,
    useBaseMenu: true,
    useRouterKey: false,
  },
  [VIEWPORT_TYPE.REALTIME_DASHBOARD]: {
    useKeepAlive: false,
    useNavigationHeader: false,
    useBaseMenu: true,
    useRouterKey: true,
  },
  [VIEWPORT_TYPE.PA]: {
    useKeepAlive: true,
    useNavigationHeader: true,
    useBaseMenu: true,
    useRouterKey: true,
  },
  [VIEWPORT_TYPE.PA_HEADER_TIME]: {
    useKeepAlive: true,
    useNavigationHeader: false,
    useBaseMenu: true,
    useRouterKey: true,
  },
  [VIEWPORT_TYPE.SETTING]: {
    useKeepAlive: false,
    useNavigationHeader: true,
    useBaseMenu: true,
    useRouterKey: false,
  },
  [VIEWPORT_TYPE.ERROR]: {
    useKeepAlive: false,
    useNavigationHeader: false,
    useBaseMenu: false,
    useRouterKey: false,
  },
} as const;

export const VIEWPORT_CLASS_NAME = {
  [VIEWPORT_TYPE.REALTIME]: 'main-viewport',
  [VIEWPORT_TYPE.REALTIME_DASHBOARD]: 'main-viewport',
  [VIEWPORT_TYPE.PA]: 'main-viewport',
  [VIEWPORT_TYPE.PA_HEADER_TIME]: 'main-viewport',
  [VIEWPORT_TYPE.SETTING]: 'config-viewport',
  [VIEWPORT_TYPE.ERROR]: 'error-viewport',
} as const;
